

import React, { useEffect, useState } from 'react';
import "./ProfileScreen.css";
import Nav from "../Nav";
import { useSelector } from 'react-redux';
import { selectUser } from '../features/userSlice';
import { auth } from '../firebase';

function ProfileScreen() {
    const user = useSelector(selectUser);
    const [highlightedPlan, setHighlightedPlan] = useState(null);

    useEffect(() => {
        const plans = ['Basic', 'Standard', 'Premium'];
        const randomPlan = plans[Math.floor(Math.random() * plans.length)];
        setHighlightedPlan(randomPlan);
    }, []);

    return (
        <div className='profile-screen'>
            <Nav />  
            <div className='profile-screen-body'>
                <h1>Edit Profile</h1>
                <div className='profile-screen-info'>
                    <img 
                        src='https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg' 
                        alt='Profile Avatar'
                    />
                    <div className='profile-screen-details'>
                        <h2>{user?.email}</h2>
                        <div className='profile-screen-plans'>
                            <h3>Plans</h3>
                            <div className={`plan-option ${highlightedPlan === 'Basic' ? 'highlighted' : ''}`}>
                                <span>Basic</span>
                                <span className='plan-price'>$8.99/month</span>
                            </div>
                            <div className={`plan-option ${highlightedPlan === 'Standard' ? 'highlighted' : ''}`}>
                                <span>Standard</span>
                                <span className='plan-price'>$13.99/month</span>
                            </div>
                            <div className={`plan-option ${highlightedPlan === 'Premium' ? 'highlighted' : ''}`}>
                                <span>Premium</span>
                                <span className='plan-price'>$17.99/month</span>
                            </div>
                            <button
                                onClick={() => auth.signOut()} 
                                className='profile-screen-signout'
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>
            </div>    
        </div>
    );
}

export default ProfileScreen;
